import { loginEndpoint, getUtenteEndpoint, logoutEndpoint } from "../endpoint";
import { makeRequest } from "../request.js";

export const login = async (param) => {
  return await makeRequest("POST", loginEndpoint(param), false, {
    usr: param.braccialetto,
    pwd: param.password,
  });
};

export const getUtente = async () => {
  const { data, result } = await makeRequest("GET", getUtenteEndpoint(), true);
  return { data, result };
};

export const logout = async () => {
  const { data, result } = await makeRequest("POST", logoutEndpoint(), true);
  return result === "OK" ? data : [];
};
